/**
 * Qual sessão está em uso: a do painel super-admin ou a de uma barbearia.
 *
 * As duas coexistem no mesmo navegador desde que cada uma tenha o seu cookie.
 * Antes ambas usavam `token` valendo em `.<rootDomain>`, então entrar numa
 * barbearia derrubava o painel e vice-versa. O painel `/admin` só existe na
 * raiz, então o caminho da URL basta para saber de quem é a vez.
 */
export type SessionScope = 'admin' | 'tenant';

export const AUTH_COOKIE = 'token';
export const ADMIN_AUTH_COOKIE = 'token_admin';

/** Header que diz à API qual sessão renovar/encerrar. */
export const SESSION_SCOPE_HEADER = 'X-Session-Scope';

export function scopeForPath(pathname: string | undefined | null): SessionScope {
  return pathname === '/admin' || pathname?.startsWith('/admin/') ? 'admin' : 'tenant';
}

export function authCookieName(scope: SessionScope): string {
  return scope === 'admin' ? ADMIN_AUTH_COOKIE : AUTH_COOKIE;
}

/** Escopo da rota aberta agora no browser. */
export function currentScope(): SessionScope {
  if (typeof window === 'undefined') return 'tenant';
  return scopeForPath(window.location.pathname);
}

/**
 * Na tela de login quem diz a sessão é o destino: `?redirect=/admin` significa
 * que o operador está entrando no painel, não numa barbearia.
 */
export function scopeForRedirectParam(search: string): SessionScope {
  return search.includes('redirect=%2Fadmin') || search.includes('redirect=/admin')
    ? 'admin'
    : 'tenant';
}

export function readCookie(name: string, cookieHeader?: string): string | undefined {
  const raw = cookieHeader ?? (typeof document === 'undefined' ? '' : document.cookie);
  const value = raw
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')[1];
  return value && value !== 'undefined' ? value : undefined;
}
